const AdminOnlyLabel = () => <span className="admin-only-label body-caption">IFTTT admin only</span>

export default AdminOnlyLabel
